<div *ngIf="loading">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>

<section>
    <form [formGroup]="form" (ngSubmit)="submit()" class="k-form-crud modal-artigo">
        <div class="modal-header p-1">
              <span mat-dialog-close class="cursor-pointer overflow-hidden btn-close-modal">
                <mat-icon>close</mat-icon>
              </span>
            <div class="w-100">
                <div class="flex-x-btw flex-y-center w-96">
                    <h2 mat-dialog-title>
                        <span *ngIf="loading; else title">Aguarde...</span>
                        <ng-template #title>{{ tituloModal }}</ng-template>
                    </h2>
                    <div *ngIf="selecionado" class="flex-y-center">
                        <button [class.btn-disable]="c.idClassificacao === classificacao?.idClassificacao"
                                (click)="seleccionarClassificacao(c)"
                                style="font-size: 14px!important;block-size: fit-content"
                                class="border-0 px-1 mr-1 rounded bg-primary h-20px"
                                *ngFor="let c of classificacoes" type="button">
                            <div style="margin-bottom: 10px;margin-top: 10px;">{{ c.classificacaoS }}</div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <mat-divider></mat-divider>
        <div class="modal-body px-05">
            <div *ngIf="!selecionado && classificacoes.length > 1" class="flex-y-center"
                 style="justify-content: center;">
                <button [class.btn-disable]="c.idClassificacao === classificacao?.idClassificacao"
                        (click)="seleccionarClassificacao(c)"
                        style="font-size: 14px!important;block-size: fit-content"
                        class="border-0 px-1 mr-1 rounded bg-primary h-20px"
                        *ngFor="let c of classificacoes" type="button">
                    <div style="margin-bottom: 10px;margin-top: 10px;">{{ c.classificacaoS }}</div>
                </button>
            </div>
            <div *ngIf="selecionado || classificacoes.length <= 1" class="p-1">
                <div fxLayout="row wrap" class="w-100">
                    <div [hidden]="!(naturezas.length > 1)" fxFlex="100" fxFlex.xl="33.33" fxFlex.lg="33.33"
                         fxFlex.md="100" class="px-1 pb-03" [class.campo-inactivo]="!classificacao">
                        <mat-form-field class="full-width" [appearance]="'outline'">
                            <mat-label>{{ classificacao?.classificacaoP }}</mat-label>
                            <mat-select formControlName="idTipoArtigo" [disabled]="!classificacao" required>
                                <mat-option (click)="aoSeleccionarTipoArtigo(nat)"
                                            *ngFor="let nat of naturezas"
                                            [value]="nat?.idTipoArtigo">{{ nat?.nome }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <!-- 1 => "Não utiliza" -->
                    <div *ngIf="classificacao?.idOpcTipo !== 1" fxFlex="100" fxFlex.xl="33.33" fxFlex.lg="33.33"
                         fxFlex.md="100" class="px-1 pb-03"
                         [class.campo-inactivo]="!classificacao">
                        <mat-form-field class="full-width" [appearance]="'outline'">
                            <mat-label>{{ classificacao?.nomeTipo }}</mat-label>
                            <mat-select formControlName="idSubTipoArtigo" [disabled]="!classificacao">
                                <mat-option>Seleccione o tipo</mat-option>
                                <mat-option *ngFor="let tipo of tipos"
                                            [value]="tipo?.idTipo">{{ tipo?.tipoArtigo }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div fxFlex="100" fxFlex.xl="33.33" fxFlex.lg="33.33" fxFlex.md="100" class="px-1 pb-03"
                         [class.campo-inactivo]="classificacao?.codigoSequencial">
                        <mat-form-field class="full-width" [appearance]="'outline'">
                            <mat-label>C&oacute;digo</mat-label>
                            <input matInput formControlName="codigoArtigo"
                                   class="uppercase" [readonly]="classificacao?.codigoSequencial"
                                   [maxLength]="classificacao?.codigoTamanho > 0 ? classificacao?.codigoTamanho : 15"
                                   required [appInputFormat]="format.Cod"
                                   placeholder="Cod. Artigo"/>
                        </mat-form-field>
                        <mat-error *ngIf="f['codigoArtigo'].hasError('minlength')"
                                   style="margin-top: 10px">
                            O código deve ter {{ classificacao?.codigoTamanho }} caracteres!
                        </mat-error>
                    </div>

                    <div fxFlex="100" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" class="px-1 pb-03"
                         [class.campo-inactivo]="!classificacao">
                        <mat-form-field class="full-width" [appearance]="'outline'">
                            <mat-label>Designação</mat-label>
                            <input matInput formControlName="nomeArtigo" placeholder="Nome do artigo" name=""
                                   maxlength="200" required
                                   [readonly]="!classificacao"/>
                        </mat-form-field>
                    </div>

                    <div *ngIf="classificacao?.usaUnidadeMedida" fxFlex="100" fxFlex.xl="25" fxFlex.lg="25"
                         fxFlex.md="100" class="px-1 pb-03">
                        <mat-form-field class="full-width" [appearance]="'outline'"
                                        [class.campo-inactivo]="!classificacao">
                            <mat-label>Unidade</mat-label>
                            <mat-select formControlName="idUnidadeMedida" required [disabled]="!classificacao">
                                <mat-option *ngFor="let unidade of unidades"
                                            [value]="unidade?.idUnidade">{{ unidade?.unidadePlural }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div fxFlex="100" fxFlex.xl="25" fxFlex.lg="25" fxFlex.md="100" class="px-1 pb-03"
                         [class.campo-inactivo]="!classificacao">
                        <mat-form-field class="full-width" [appearance]="'outline'">
                            <mat-label>Preço</mat-label>
                            <input formControlName="precoArtigo" matInput style="text-align: right"
                                   [readonly]="!classificacao"
                                   placeholder="Preço do {{classificacao?.classificacaoS}}" name=""
                                   [appInputFormat]="format.Decimal"/>
                        </mat-form-field>
                    </div>
                    <div fxFlex="100" fxFlex.xl="30" fxFlex.lg="30"
                         fxFlex.md="100" class="px-1 pb-03"
                         [class.campo-inactivo]="!classificacao">
                        <mat-form-field class="full-width" [appearance]="'outline'">
                            <mat-label>IVA*</mat-label>
                            <mat-select formControlName="idImposto" [disabled]="!classificacao">
                                <mat-option *ngFor="let iva of impostos"
                                            [value]="iva?.idImposto">
                                    {{ iva.codImposto }} -{{ iva.taxa }}% - {{ iva.descricao }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <!-- Movimenta Stock -->
                    <div *ngIf="gereStock && classificacao?.idOpcGereStocks !== 1 && classificacao?.codNatureza === 'P'"
                         fxFlex="10"
                         fxFlex.xl="30"
                         fxFlex.lg="30" fxFlex.gt-xs="50" fxFlex.xs="100" style="padding-top: 12px;">
                        <div class="pl-16 pr-16">
                            <mat-slide-toggle class="font-weight-bold text-primary"
                                              formControlName="gereEstoque" color="primary">
                                Gestão de Stocks
                            </mat-slide-toggle>
                        </div>
                    </div>

                    <div fxFlex="100" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" class="px-1 pt-1">
                        <p *ngIf="form.invalid && submitted" class="text-error"><small>Todos os campos marcados com
                            asterisco são obrigatórios!</small></p></div>
                </div>

            </div>
        </div>
        <div style="bottom: 15px">
            <div class="flex-x-btw pt-4 px-1 pb-1">
                <button color="primary" [mat-dialog-close]="true" mat-button class="mr-1 bg-secondary" type="button">
                    Cancelar
                </button>
                <button [class.btn-disable]="!classificacao || loading" color="primary" mat-button
                        class="ml-1 bg-primary"
                        [disabled]="!classificacao || loading">Gravar
                </button>
            </div>
        </div>
    </form>
</section>
